export { default as perfConfig, isPageLoadInstrumented } from './perf-config';
